import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  fromPay: false,
  parkId: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    ladingStatus(state, action) {
      state.isLoading = action.payload.conditional;
    },
    wasFromPay(state, actions) {
      state.fromPay = actions.payload.conditional;
      state.parkId = actions.payload.parkId;
    },
    toReset(state) {
      Object.assign(state, initialState);
    },
  },
});

const uiActions = uiSlice.actions;
const uiReducer = uiSlice.reducer;

export { uiActions, uiReducer };
